function initScrollReveal() {
  const items = document.querySelectorAll('.js-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      entry.target.classList.toggle('is-visible', entry.isIntersecting);
    });
  }, { threshold: 0.2 });

  items.forEach((el) => io.observe(el));
}

document.addEventListener('DOMContentLoaded', initScrollReveal);
